import { render, staticRenderFns } from "./DictSelect.vue?vue&type=template&id=6da435c0&scoped=true"
import script from "./DictSelect.vue?vue&type=script&lang=js"
export * from "./DictSelect.vue?vue&type=script&lang=js"
import style0 from "./DictSelect.vue?vue&type=style&index=0&id=6da435c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da435c0",
  null
  
)

export default component.exports